const commonEn = {
  commonLang: {
    客户名称: 'Customer name',
    平台功能更新说明: 'Platform function update description',
    查看: 'Examine',
    请选择: 'Please select',
    修改密码: 'Change password',
    退出登录: 'Logout',
    数据大屏: 'Data screen',
    多站总览: 'Multi site Overview',
    站点卡片: 'Station Card',
    单站数据: 'Single station data',
    电站概览: 'Overview of the power plant',
    站点系统: 'Site System',
    设备监控: 'Equipment monitoring',
    故障告警: 'Fault Alarm',
    电价管理: 'Electricity price management',
    统计报表: 'Statistical report',
    电量报表: 'Electricity report',
    收益报表: 'Income statement',
    运维管理: 'Operation and maintenance management',
    工单管理: 'Work order management',
    系统管理: 'System management',
    电站管理: 'Power station management',
    公共模版: 'Public template',
    账号管理: 'Account management',
    收起: 'Retract',
    原密码: 'Old password',
    请输入原密码: 'Please enter the old password',
    新密码: 'New password',
    请输入新密码: 'Please enter your new password',
    确认新密码: 'Confirm new password',
    请输入确认密码: 'Please enter your confirmation password',
    取消: 'Cancel',
    确定: 'Confirm',
    两次密码不一致请重新输入: 'The two passwords are inconsistent. Please re-enter them!',
    '密码更改成功，请重新登录': 'Password changed successfully, please log in again!',
    提示: 'Hint',

    该账号目前没有资源权限即将返回登录页: 'This account does not currently have access and will soon return to the login page...',
    智慧储能云平台: 'EMS Cloud Platform',
    工商业储能云平台: 'EMS Cloud Platform',
    '驰硕-智慧储能云平台': 'ChiShuo-EMS Cloud Platform',
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台',
    赛唯E宝工商业储能云平台: 'SAV Energy Storage Cloud Platform',
    STE智慧储能云: 'Santie Intelligent Energy Storage Cloud Platform',
    '云基慧-智慧储能云平台': 'Ujoinwe-Intelligent Energy Storage Cloud Platform',
    鹏洲储能云平台: 'Pengzhou Energy Storage Cloud Platform',
    工商业储能数据云平台: 'Industrial and commercial energy storage data cloud platform',
    智慧储能管控平台: 'Intelligent energy storage cloud platform',
    中汇芯能智慧云平台: '中汇芯能智慧云平台',
    请输入合法数字: 'Please enter a legal number',
    手机号码格式不正确: 'Mobile phone number format is incorrect!',
    邮箱格式不正确: 'The mailbox format is incorrect',
    密码必须由6至20个字符组成支持字母不区分大小写数字和特殊符号: 'Passwords must consist of 6 to 20 characters and support letters (case insensitive), numbers, and special symbols.',
    该账号目前没有权限访问: 'This account is currently not authorized to access',
    个人信息: 'Personal information',

    账号名称: 'Account name',
    账号邮箱: 'Account email',
    账号手机: 'Account phone',
    账号角色: 'Account role',
    创建时间: 'Creation time',
    创建人: 'Founder',
    到期时间: 'Maturity time',

    '赛唯E宝 工商业储能云平台': 'SAV Energy Storage Cloud Platform'
  }
}
export default commonEn
